'use strict';

import React from 'react';
import * as d3request from 'd3-request';

class GtmTracking extends React.Component {

  constructor(state) {
    super(state);

    this.state = {
      ... state,
      gtmId: ''
    }
  }

  componentDidMount() {

    let hostname = window.location.hostname;

    // to avoid a error message on localhost
    if (hostname == 'localhost') {
      //hostname = 'www.tagesanzeiger.ch';
      return;
    }

    hostname =
      hostname.substring(hostname.lastIndexOf('.',
          hostname.lastIndexOf('.') - 1) + 1); // extract domain name from host
                                               // (crops subdomains like
                                               // interaktiv.)

    //TODO Move this request to Statistics component – no need to do the
    // same request twice
    d3request.json('http://www.' + hostname + '/api/sites/default')
      .get((error, siteData) => {
        if (error) {
          console.log(error);
          return;
        }

        let gtmId = siteData.site.gtm_id;

        // Trigger the rendering of the iframe
        this.setState({
          gtmId: gtmId
        });

        //region Code Snippet from Google
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push(
            {
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
            }
          );
          var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !=
          'dataLayer' ?
          '&l=' +
          l :
            '';
          j.async = true;
          j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);

        })(window, document, 'script', 'dataLayer', gtmId);
        //endregion

      });
  }

  render() {

    if (this.state.gtmId === '') {
      return null;
    }

    return (
      <iframe src={`//www.googletagmanager.com/ns.html?id=${this.state.gtmId}`}
              height='0' width='0'
              style={{display: 'none', visibility: 'hidden'}}></iframe>
    );
  }

}

GtmTracking.propTypes = {};

GtmTracking.defaultProps = {};

export default GtmTracking;



/** WEBPACK FOOTER **
 ** ./src/components/gtmTracking/GtmTracking.js
 **/